module.exports = __webpack_public_path__ + "static/media/china-poster.25216d7d.png";